import { memo, type CSSProperties } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Paper, PaperProps, Typography, Box } from '@mui/material';

interface Props extends PaperProps {
    loading?: boolean;
    style?: CSSProperties;
    elevation?: number;
    message?: string;
}
const LoadingPaper = (props: Props) => {
    const { children, elevation, loading, style, message, ...rest } = props;

    if (loading) {
        return (
            <Box
                sx={{
                    textAlign: 'center',
                    padding: '5rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '60%',
                }}
            >
                <CircularProgress />
                {message ? (
                    <Typography variant="h6" sx={{ alignSelf: 'center', marginTop: '3rem' }}>
                        {message}
                    </Typography>
                ) : null}
            </Box>
        );
    } else {
        return (
            <Paper elevation={elevation ? elevation : 0} sx={style} {...rest}>
                {children}
            </Paper>
        );
    }
};

export default memo(LoadingPaper);
